var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    ref: "link",
    staticClass: "open",
    attrs: {
      "href": "comic001",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_commic001.svg"),
      "alt": "第1話"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    ref: "link2",
    staticClass: "open",
    attrs: {
      "href": "comic002",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_commic002.svg"),
      "alt": "第2話"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    ref: "link3",
    staticClass: "open",
    attrs: {
      "href": "comic003",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_commic003.svg"),
      "alt": "第3話"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    ref: "link3",
    staticClass: "open",
    attrs: {
      "href": "comic004",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_commic004.svg"),
      "alt": "第4話"
    }
  })])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('a', {
    ref: "link3",
    staticClass: "open",
    attrs: {
      "href": "comic005",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_commic005.svg"),
      "alt": "第5話"
    }
  })])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("あの「東京タラレバ娘」や「海月姫」の原作者"), _c('br', {
    staticClass: "break-xs"
  }), _vm._v("東村アキコ先生が"), _c('br'), _vm._v("学生時代から愛用されている"), _c('br', {
    staticClass: "break-xs"
  }), _vm._v("「とり野菜みそ」のエッセイ漫画を描き下ろし！"), _c('br'), _vm._v("超！超！超！レアな「まつや」オリジナル漫画を"), _c('br', {
    staticClass: "break-xs"
  }), _vm._v("全5話完結で順次公開いたします！")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "balloon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_comic_balloon_new.svg"),
      "alt": "最新話"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65506aa9","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comic.vue
// module id = 51
// module chunks = 0